const STORE_MENU_CONTEXT_VERSION = 1 as const

export type StoredStoreMenuContext = {
  version: typeof STORE_MENU_CONTEXT_VERSION
  storeNo: string
  storeId: string | number
  menuCode: string
  updatedAt: string
}

const getStorageKey = (storeNo: string) =>
  `store-menu-context:v${STORE_MENU_CONTEXT_VERSION}:${storeNo}`

export const readStoreMenuContext = (
  storeNo?: string | null,
): StoredStoreMenuContext | null => {
  if (!storeNo || typeof window === 'undefined') return null

  const rawContext = localStorage.getItem(getStorageKey(storeNo))
  if (!rawContext) return null

  try {
    const context = JSON.parse(rawContext) as Partial<StoredStoreMenuContext>

    if (
      context.version !== STORE_MENU_CONTEXT_VERSION ||
      context.storeNo !== storeNo ||
      context.storeId == null ||
      !context.menuCode
    ) {
      return null
    }

    return context as StoredStoreMenuContext
  } catch {
    return null
  }
}

export const persistStoreMenuContext = (
  context: Pick<StoredStoreMenuContext, 'storeNo' | 'storeId' | 'menuCode'>,
) => {
  if (typeof window === 'undefined') return

  localStorage.setItem(
    getStorageKey(context.storeNo),
    JSON.stringify({
      version: STORE_MENU_CONTEXT_VERSION,
      ...context,
      updatedAt: new Date().toISOString(),
    } satisfies StoredStoreMenuContext),
  )
}
